<div class="d-flex gap-2 align-items-center">
  <p-checkbox
    [binary]="binary"
    [disabled]="disabled || isDisabled"
    [name]="name"
    [value]="value"
    [inputId]="inputId"
    [styleClass]="styleClass"
    [style]="style"
    [ariaLabel]="ariaLabel"
    [ariaLabelledBy]="ariaLabelledBy"
    [tabindex]="tabindex"
    [trueValue]="trueValue"
    [falseValue]="falseValue"
    [readonly]="readonly"
    [required]="required"
    [variant]="variant"
    [ngModel]="model"
    (ngModelChange)="handleModelChange($event)"
    (onBlur)="handleBlur()"
    [ngModelOptions]="{ standalone: true }"
    [size]="size"
  ></p-checkbox>
  @if (label) {
    <label [for]="inputId" [ngClass]="labelStyleClass" [ngStyle]="labelStyle">{{
      label
    }}</label>
  }
</div>

<style>
  label {
    cursor: pointer;
  }
</style>
